import { UniversalClip } from '../universal';

export type AUDIO_PLAYER = 'cap_audio';
export type TRITON_PLAYER = 'cap_triton';

export interface IMedia {
  slug: string;
  mountPoint: string;
  mountPointHD: string;
  mp3Stream: string;
  audioAac: string;
  audioHls: string;
  duration: number | undefined;
  contentType: string;
  contentId: string;
  getStreamSource: () => ActivePodcastOrStation;
}

interface ListenerFn {
  (...values: any[]): void;
}
export interface IEventDispatcher {
  sendEvent: <T>(type: string, objParams?: T) => void;
  on: (type: string, listener: ListenerFn) => void;
  removeListener: (type: string, listener: ListenerFn) => void;
}

export interface IEvent {
  time: number;
  name: string;
  duration?: number;
  volume?: number;
  player: AUDIO_PLAYER | TRITON_PLAYER;
  contentType: string;
  media: IMedia;
}

export enum PlayerEvents {
  STREAM_METADATA_LOADED = 'loadedmetadata',
  STREAM_START = 'stream-start',
  STREAM_STOP = 'stream-stop',
  STREAM_PAUSE = 'pause',
  STREAM_SWITCH = 'stream-switch',
  STREAM_ENDED = 'stream-ended',
  PLAYER_DISCONNECTED = 'disconnected',
  PLAYER_PLAYING = 'playing',
  PLAYER_EMPTIED = 'emptied',
  STREAM_RESUMED = 'stream-resumed',
  STREAM_ERROR = 'stream-error',
  STREAM_STATUS = 'stream-status',
  STREAM_STALLED = 'stream-stalled',
  TRACK_CUE_POINT = 'track-cue-point',
  HEARTBEAT = 'heartbeat',
  ONLINE = 'online',
  OFFLINE = 'offline',
  PLAYER_RECONNECT = 'player_reconnect',
  PLAYER_RECONNECTING = 'player_reconnecting',
  VOLUME_CHANGED = 'volumechange',
  STREAM_MUTED = 'stream-muted',
  STREAM_UNMUTED = 'stream-unmuted',
  STREAM_MUTE_STOP = 'stream-mute-stop',
  STREAM_UNMUTE_START = 'stream-unmute-start',
  TIME_UPDATE = 'timeupdate',
  DURATION_CHANGE = 'durationchange',
  STREAM_CONFIG_ERROR = 'stream-config-error',
  STREAM_FAIL = 'stream-fail',
  STREAM_CONFIG_LOAD_ERROR = 'stream-config-load-error',
}

export enum StreamType {
  STATION = 'station',
  PODCAST = 'podcast',
  CLIP = 'clip',
}

export enum PlaybackMode {
  LIVE_AUDIO = 'LIVE_AUDIO',
  ON_DEMAND_CLIP = 'ON_DEMAND_CLIP',
}

export enum PlayerType {
  AUDIO = 'audio',
  TRITON = 'triton',
}

export interface IPlayerState {
  trackStreamStart?: boolean;
  mediaMetadata?: ActivePodcastOrStation;
  volumeLevel?: number;
  playerVersion?: string;
}

export interface IPlayerStateManager {
  getState: () => IPlayerState;
  setState: (state: Partial<IPlayerState>) => void;
}

export type ActivePodcastOrStation = {
  id: string;
  contentTypeId: string;
  title: string;
  slug: string;
  media: {
    source: string;
    uri: string;
  }[];
  images?: [
    {
      uri: string;
      imageType: string;
    }
  ];
  podcastTitle?: string;
  description?: string;
  episode?: UniversalClip;
  publishDate?: string;
  season?: number;
  durationSeconds?: number;
  reference?: any;
};
